import React, { useEffect, useState } from "react";
import { FormGroup, Button, Container } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { FetchBeds, UpdateBed } from "../../apis/Bed";
import { AxiosError } from "axios";

const Bed = () => {
  const [updateData, setUpdateData] = useState({
    itemName: "",
    otherItemName: "",
    startValue: "",
    endValue: "",
  });
  const navigate = useNavigate();

  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "Bed", link: "#" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await FetchBeds();

        if (data && data.bed) {
          setUpdateData({
            itemName: data.bed.itemName,
            otherItemName: data.bed.otherItemName,
            startValue: data.bed.startValue,
            endValue: data.bed.endValue,
          });
        }
      } catch (error) {
        toast.error("Failed to fetch data");
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { itemName, otherItemName, startValue, endValue } = updateData;

      const response = await UpdateBed(
        itemName,
        otherItemName,
        startValue,
        endValue
      );
      if (response) {
        toast.success("Bed Created Successfully");
        navigate("/bed");
      } else {
        toast.error("Bed Creation Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };
  const validateStartValue = () => {
    return parseFloat(updateData.startValue) > 0
      ? true
      : "Start Value must be greater than 0";
  };
  // Custom validation to ensure endValue is greater than startValue
  const validateEndValue = () => {
    return parseFloat(updateData.endValue) > parseFloat(updateData.startValue)
      ? true
      : "End Value must be greater than Start Value";
  };
  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]" fluid>
        <Breadcrumbs title="Add Bed" breadcrumbItems={breadcrumbItems} />
        <div className="p-6 flex flex-col gap-6 ">
          <h1 className="text-2xl dark:text-[#c7d8eb]">Beds</h1>
          <div className="lg:flex flex-col w-full lg:max-w-4xl mx-auto p-4 lg:rounded-lg lg:border border-gray-400 dark:border-white">
            <AvForm onValidSubmit={handleSubmit}>
              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="itemName"
                  label="Bed Name"
                  placeholder="Type bed name"
                  type="text"
                  errorMessage="Enter Name"
                  validate={{ required: { value: true } }}
                  value={updateData.itemName}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      itemName: e.target.value,
                    })
                  }
                />
              </div>

              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="otherItemName"
                  label="Bed's other Name"
                  placeholder="Type bed's other name"
                  type="text"
                  errorMessage="Enter Name"
                  validate={{ required: { value: true } }}
                  value={updateData.otherItemName}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      otherItemName: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="startValue"
                  label="Start value"
                  placeholder="Type start value"
                  type="number"
                  errorMessage="Enter Start Value"
                  validate={{
                    required: { value: true },
                    custom: validateStartValue,
                  }}
                  value={updateData.startValue}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      startValue: e.target.value,
                    })
                  }
                />
              </div>

              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="endValue"
                  label="End Value"
                  placeholder="Type end value"
                  type="number"
                  errorMessage="Enter End Value "
                  validate={{
                    required: { value: true },
                    custom: validateEndValue,
                  }}
                  value={updateData.endValue}
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      endValue: e.target.value,
                    })
                  }
                />
              </div>

              <FormGroup className="mb-0">
                <div>
                  <Button type="submit" color="primary" className="me-1">
                    Update
                  </Button>
                </div>
              </FormGroup>
            </AvForm>
          </div>
        </div>
      </Container>
      </div>
    </React.Fragment>
  );
};

export default Bed;
